import { environment } from '../environments/environment';
import { Component, OnInit, OnDestroy, HostListener, ElementRef, ViewContainerRef, ViewChild } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, ActivatedRoute } from '@angular/router';
import { DnDialogService } from './_modules/dn-dialog/dn-dialog.service';
import { UserService } from './_service/user/user.service';
import { Subscription, timer } from 'rxjs';
import { GgService } from './_service/gg/gg.service';
import { ScrollStoreProvider } from './ScrollStoreProvider';
import { Location } from '@angular/common';
import { StorageService } from './storageprovider';
import { Utility } from './_service/utility';
import { PermissionService } from './PermissionService';
import { NotifyService } from './_service/notify/notifyService';
import { NotifyType } from './_service/notify/notifyModel';
import { SocketFacade } from './_modules/socket/socket.facade';
import { ConfigService } from './_service/config/config.service';
import { GuideService } from './_service/guide/guide.service';
import { FullScreenService } from './_service/full-screen/full-screen.service';
import { StickyChatService } from './_modules/sticky-chat/sticky-chat.service';
import { ScriptService } from './_service/script.service';
import { NewsService } from './_service/news/news.service';
import { SettingsService } from './user-center/settings/settings.service';
import { DynamicComponentLoader } from './_service/dynamicComponentLoader.service';
import { RechargeBoxService } from './_service/recharge-box/recharge-box.service';
import { RechargeService } from './_service/recharge/recharge.service';
declare var gtag;
@Component({
  selector: 'div.root-container',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [
    ScrollStoreProvider
  ]
})

export class AppComponent implements OnInit, OnDestroy {

  siteTitle = this._utility.getSiteConfig.title;
  officialSite = environment.officialSite;
  isAdult = environment.cinema === 2;

  private subscriptions: Subscription[] = [];
  //confimed = false;
  //isIe = false;
  isDanger = this._utility.getWindow().top != this._utility.getWindow() || (environment.allowHost.length > 0 && environment.allowHost.findIndex(p => this._utility.getLocation().host.indexOf(p) > -1) == -1)
  counter: number;
  showDialog = false;
  user;
  region;
  regionStateInit = true;

  ifGuide = false;
  currentLocation = "";
  showStickyChat = false;
  constructor(
    private router: Router,
    private _dnDialogService: DnDialogService,
    private _userService: UserService,
    private _ggService: GgService,
    private _scrollProvider: ScrollStoreProvider,
    private location: Location,
    private _storage: StorageService,
    private _permission: PermissionService,
    private _notifyService: NotifyService,
    private _location: Location,
    private _elementRef: ViewContainerRef,
    private socketFacade: SocketFacade,
    private _guide: GuideService,
    private configService: ConfigService,
    private fullScreenService: FullScreenService,
    private _stickyChatService: StickyChatService,
    private _route: ActivatedRoute,
    private _utility: Utility,
    private _script: ScriptService,
    private _newsService: NewsService,
    private settingsService: SettingsService,
    private _dcl:DynamicComponentLoader,
    private _rechargeService:RechargeService
  ) {

    this._utility.GetCurrentLocation = () => {
      return this.currentLocation;
    }
    this.currentLocation = this._location.path();
    var token = this._storage.GetLocalSession();
    if (token) {
      //console.log(token)
      this._userService.updateUserToken(JSON.parse(token))
      this._userService.login();
    }
    this.applyDarkTheme();
    this._dcl.setViewContainer(this._elementRef);
    // this._userService.setViewContainer(this._elementRef);
    // this._dnDialogService.setViewContainer(this._elementRef);
 
  }

  //private isApplied = false;
  // private isApplied = false;
  // private isDark = false;
  applyDarkTheme() {
    // var isDark = Utility.isTimeDark();
    // if (!environment.switchBaseOnTime) {
    //   isDark = false;
    // }
    var isDark = !!parseInt(this._storage.GetConfig()["isDark"]);
    if (this._storage.GetConfig()["isDark"] === undefined) {
      this._storage.SetConfig({ isDark: 1 }); // 设置默认为深色
      //this.applyDarkTheme();
      return;
    }

    if (isDark) {



    }
    else {
      document.body.classList.add('light');

    }


  }

  private watcher = null;
  // private usedValue = "";
  // private count = 0;
  private lastToken = '';
  readState() {
    // console.log("APP read state", this.count++);
    if (!!this.user.id
      && this.lastToken != this.user.token.token) {
      this.lastToken = this.user.token.token;
      this.onUserLogin();
    }
    else if (!!this.lastToken
      && this.lastToken != this.user?.token?.token) {
      this.lastToken = '';
      this.onUserLogout();
    }

    this.userMonitorEvent();
    this.productSubscript();


  }

  private productTimeout = null;
  private productSubscript()
  {
    clearTimeout(this.productTimeout);
    this._rechargeService.getProductsAndPayment().subscribe(res=>{
      this._rechargeService.changeProductState(res);
      if (res.discountInfo.length > 0) {
        let endtime = Math.min(res.discountInfo.map(p=>p.endTime));
        this.productTimeout = setTimeout(()=>{
          this._rechargeService.clearState();
          this.productSubscript();
        },endtime *  5000)
      }


    });
  }

  private tryRenewTimes = 0;
  /*
  ** 确保用户GID一致
  */
  private userGroupSyncAction() {
    const token = this._storage.GetSessionData("token");
    var result = true;
    if (token &&
      this.user
      && this.user.id
      && this._userService.shouldrenewUser) /// 用户付款后？，对数据进行重写
    {
      this._userService.validateToken(token).subscribe((res) => {
        var newUser = res;
        if (newUser["token"]["gid"] != this.user.token.gid) {
          //console.log("user account update")
          this.user.token.sign = newUser["token"]["sign"];
          this.user.token.token = newUser["token"]["token"];
          this.user.token.expire = newUser["token"]["expire"];
          this.user.token.gid = newUser["token"]["gid"];
          this._userService.cancelRenew();
          var obj = Object.assign({
            uid: this.user.id
          }, this.user.token);
          this._userService.updateUserToken(obj);
          this._userService.getAuthorizedUserInfo(newUser).subscribe();
        }

      });


      if (this.tryRenewTimes > 5) {
        this._userService.cancelRenew();
        this.tryRenewTimes = 0;
      }
      else {
        this._userService.renewCurrentUser();
        ++this.tryRenewTimes;
      }

    }
    return result;
  }

  /*
  ** 确保用户token一致
  */
  private userTokenSyncAction() {
    const token = this._storage.GetSessionData("token");
    var result = true;
    if (!!this.user.id) ///当前用户是登录状态
    {
      if (this.user.token.token != token && !!token) {
        this.showInfo('用户数据错误，请重新登录');
        this._userService.logout();
        result = false;
      }
      else if (!token) {
        this.showInfo('您已退出登录')
        this._userService.logout();
        result = false;
      }
      this.syncCount = 0;
    }
    else {
      if (token) {

        if (this.syncCount == 0) {
          ++this.syncCount;
          this.loginUserByToken(token);
        }
        else {
          this.showInfo("用户信息同步失败，请重新登录");
          this._userService.logout();
          result = false;
        }

      }

    }
    //console.log(this.syncCount);
    return result;
  }


  ///用户信息监控，每10秒一次
  private userMonitorEvent() {
    if (this.watcher == null) {
      this.watcher = timer(2000, 1000 * 10).subscribe(() => {
        return this.userTokenSyncAction()
          && this.userGroupSyncAction()
      })
      this.subscriptions.push(this.watcher);

    }

  }

  private syncCount = 0;
  /*
  ** 根据令牌信息，登录用户
  */
  private loginUserByToken(token: string) {
    this._userService.validateToken(token).subscribe((res) => {
      var newUser = res;
      if (newUser != null) {
        this._userService.updateUserToken(Object.assign({
          uid: newUser.id,
        },
          newUser.token
        ));
        this._userService.getAuthorizedUserInfo(newUser).subscribe();
      }
    })
  }


  /*
  ** 显示一个消息框
  */
  private showInfo(msg) {
    // this._messageDialogService.setState({ message: msg, style: { 'text-algin': 'center' } });
    this._dnDialogService.open('message-dialog',{ message: msg, style: { 'text-algin': 'center' } });
  }

  private onUserLogin() {

    this._notifyService.isLogin = true;
    this._permission.invokeList(null);
    this._userService.getUserPermissions(this.user).subscribe(res => {
      // this.store.dispatch({ type: userActions.SETPERMISSIONS, permissions: res });
      this._permission.invokeList(res);
      this._permission.invokeUser({
        level: this.user.level || 0,
        group: this.user.token.gid
      });
      // 从后端获取初始化设置
      if (!!this.user.id) {
        this.loadInitSettings();
      }
      // console.log(this.user);
      //  console.log(res);
      //this.store.dispatch({ type: userActions.SETPERMISSIONS, permissions: res });
    });
    if (!environment.disableNotify) {
      this._notifyService.isLogin = !!this.user.id;
      this._notifyService.init(this.user.id);

    }

    this.subscriptNotify();
    //console.log("user login")
  }

  private onUserLogout() {


    if (this._notifyService.isLogin) {
      this._notifyService.isLogin = false;
      this._permission.invokeList(null);
      this._notifyService.clear();
      this.onece = false;

    }
    // 用户退出后，关闭强提醒
    this._stickyChatService.updateState(false);
    //  console.log("user logout")

  }

  scrollBarTimeout = null;

  testPublic() {
    this._utility.canViewPublic = !window["isAdsBlocked"];
    setTimeout(() => {
      this._utility.canViewPublic = !window["isAdsBlocked"];///
    }, 5000);
  }

  traceCode = '';
  @ViewChild("playVideo", { static: true }) video: ElementRef;
  ngOnInit() {

    //this.dnFocusesService.getDnFocuses("0,1", this._storage.GetConfig()["region"]);
    let timeout = null;
    let first = true;
    this.configService.getRemoteConfig();
    this.subscriptions.push(
      this._userService.userState$.subscribe(user => {
        this.user = user;
        this.readState();
      }),
      this.configService.config$.subscribe(p => {
        if (!!p.apiVersion) {
          if (!!p.analiticStr) {
            this._script.loadScript("gtag", {
              isAsync: true,
              isHeadLoad: false,
              params: {
                gtagID: p.analiticStr
              }
            });
            this.traceCode = p.analiticStr
            gtag('config', p.analiticStr, {
              send_page_view: false
            });
            gtag('event', 'page_view', {
              page_path: this._utility.GetCurrentLocation()
            });
          }

          if (!!p.pConfig) {
            this._userService.shortCut(p.pConfig);
          }
        }
      }),
      this.fullScreenService.fullScreenState$.subscribe(fullScreen => {
        // console.log(fullScreen);
        this.isFullScreen = fullScreen;
      }),
      this._stickyChatService.showSticky.subscribe(state => {
        if (state !== undefined) {
          this.showStickyChat = state;
        };
      }),
    )
    if (this._utility.isSafari()) {
      document.body.classList.add('safari');
    }

    this.testPublic();




    //this.deviceInfo = this.deviceService.getDeviceInfo();
    let fromUrl = "";
    let toUrl = ""
    this.subscriptions.push(
      this.router.events.subscribe((evt) => {
        if (evt instanceof NavigationStart) {
          // console.log("start nav");
          if (!this.shouldnotRecord) {
            this._scrollProvider.handleScroll(this._utility.getLocation().pathname + this._utility.getLocation().search);
          }
          this.shouldnotRecord = false;
          fromUrl = this._utility.GetCurrentLocation();
          this.currentLocation = evt.url;
          if (this.video != null && timeout == null && !first) {
            console.debug("video played");
            (this.video.nativeElement as HTMLVideoElement).play();
            timeout = setTimeout(() => {
              this.video.nativeElement.remove();
            }, 500)

          }
          toUrl = this.currentLocation;//Utility.GetCurrentLocation();
          first = false;
          console.debug("on route change");
        }
        if (evt instanceof NavigationEnd) {
          var fromTo = `${fromUrl}->${toUrl}`
          this.updateAllGgs();
          console.debug("get cached Position", this.cachedPosition)
          if (this.cachedPosition > 0) {
            if (this.scrollBarTimeout != null) {
              clearTimeout(this.scrollBarTimeout);
            }

            this.scrollBarTimeout = setTimeout(() => {
              this._utility.getWindow().scrollTo(0, this.cachedPosition);
              this.cachedPosition = 0;
            }, 100)
          }
          else {
            //console.log("fromURL:"+fromUrl+" toURL:"+toUrl)
            if (!this._utility.isSameRoute(fromUrl, toUrl))
              this._utility.getWindow().scrollTo(0, 0);
          }


          if (this.traceCode) {
            gtag('event', 'page_view', {
              page_path: evt.urlAfterRedirects
            });

          }

          if (!this._utility.isUrlDirectionContains(fromTo, ["/watch->/", "/->/watch"])) {
            this._newsService.clearCache();
          }


          if (this._utility.isUrlContains(["/challenge", "/payment"])) {
            this.hideTop = true;
            this.hideSticky = true;
          }
          else {
            this.hideTop = false;
            this.hideSticky = false;
          }
          if (this._utility.isUrlContains(["/user/messages/chat"])) {
            this.hideStickyChat = true;
          } else {
            this.hideStickyChat = false;
          }
          console.debug("on route change end");
        }



      })
    );
    if (!this._utility.isBot()) {
      this.subscriptions.push(
        this._guide.guideCover.subscribe(state => {
          setTimeout(() => {
            this.ifGuide = state;
          }, 50);
        }))
    }


    /// 用户自动登录
    const token = this._storage.GetSessionData("__t");
    const autoKey = this._storage.GetCookie('autologin').replace(/"/g, "");
    if (!token && autoKey) {
      this
        ._userService
        .loginUserWithKey(autoKey)

    }


    // if (environment.app) {
    //   fromEvent(window, "sessionAuto").subscribe((event: CustomEvent) => {
    //     if (event.detail) {
    //       this
    //         ._userService
    //         .loginUserWithKey(event.detail)
    //     }
    //   })
    // }


    this.location.subscribe(p => {
      var pos = this._scrollProvider.restoreScroll(p.url);
      if (pos.exist) {
        this.cachedPosition = pos.position;
        this.shouldnotRecord = true;
      }

    })

    window["dnapublic"] = 'cd7bfe907329c083389fffd24563fa80';
    if (!!window["__Initialize"])
      window["__Initialize"]();

    this._notifyService.onnect.subscribe(p => {

      if (!!this.user.id) {
        this.authorizeUser();
      }
    });

    var said = false;
    this._route.queryParams.subscribe(p => {
      if ((p.from == '1' || p.from == '') && !said) {
        said = true;
        this._dnDialogService.open("ask-leave-dialog")
      }
    })

    this.initDevicePixelRatio();
    if (this._utility.isUrlContains(["/notice", "/help/download", "/challenge", "/payment"])) {
      this.hideTop = true;
      this.hideSticky = true;
    }

    /*
    ** 检测用户是否在本tab
    */
    const vis = (function () {
      var stateKey, eventKey, keys = {
        hidden: "visibilitychange",
        webkitHidden: "webkitvisibilitychange",
        mozHidden: "mozvisibilitychange",
        msHidden: "msvisibilitychange"
      };
      for (stateKey in keys) {
        if (stateKey in document) {
          eventKey = keys[stateKey];
          break;
        }
      }
      return function (c) {
        if (c) document.addEventListener(eventKey, c);
        return !document[stateKey];
      }
    })();
    vis(() => {
      this._utility.isDocumentVisible = vis(null);
      // console.log("document state:" + this._utility.isDocumentVisible)
    });
  }


  private onece = false;

  notifySubscription = [];

  /*
  ** 通知服务，监听用户信息事件
  */
  subscriptNotify() {

    this.notifySubscription.forEach(p => p.unsubscribe());
    this.notifySubscription = [];

    this.addNotifyCallback(NotifyType.Conn, (p) => {
      //console.log(p)
      if (p && p.length > 0 && p[0] == "ok") {
        // console.log("logined");
        this.addNotifyCallback(NotifyType.UserStateChange, (msg) => {
          //console.log(msg);
          switch (msg.action) {
            case 0: ///用户VIP等级修改
              this.showInfo(msg.context);
              this._userService.renewCurrentUser();
              break;
            case 1:  //用户的状态修改，比如密码，所在区域
              this.showInfo(msg.context);
              this.logout();
              break;
            case 2: //私信
              this._utility.Notify("user.newMessage", msg);
              break;


          }
          // if (msg.action != 2) {
          //   this.showInfo(msg.context);
          // }

          // if (msg.action == 0) ///用户VIP等级修改
          // {
          //   this._userService.renewCurrentUser();
          // }
          // else if (msg.action == 1) //用户的状态修改，比如密码，所在区域
          // {
          //   this.logout();
          // }
          // else if (msg.action == 2) { ///用户有新的消息
          //   this._utility.Notify("user.newMessage", msg);
          // }

        });

        /*
        ** 私信
        */
        this.addNotifyCallback(NotifyType.PrivateMessage, (data) => {
          // console.log(data, "12341234123")
          // if (data.messageType )
          this.socketFacade.receiveMessage({
            ...data,
            messageType: data.messageType === 1 ? 'text' : 'image',
            context: data.messageType === 1
              ? data.processContext ? data.processContext : data.context
              : data.context,
          });
        });

        /*
        ** 异地登录
        */
        this.addNotifyCallback(NotifyType.UserLiveTest, (data) => { ///这里是通知到某端
          console.log("mutiple device login")
          this.showInfo(data.msg || "您的帐号已在其他 地方/设备 登录");
          this.logout();
        });


      }

    });
    this.authorizeUser();

  }
  /*
  ** 向通知服务器发送验证用户信息。这里只需验证一次
  */
  private authorizeUser() {
    if (!!this.user.id && !this.onece && this._notifyService.isconnected) {

      this.onece = true;
      var obj = {
        token: this.user.token.token,
        expire: this.user.token.expire,
        uid: this.user.id,
        gid: this.user.token.gid,
        sign: this.user.token.sign,
        nickname: this.user.nickname,
        version: "1.0.3"
      };
      //  console.log(this.user)
      this._notifyService.authorize(obj);
    }

  }

  /*
  ** 处理消息，在用户登出后，清空
  */
  private addNotifyCallback(action: NotifyType, callback) {
    // console.log(action);
    this.notifySubscription.push(this._notifyService.on({
      action: action,
      data: null,
      code: 0
    }).subscribe(callback));
  }


  /*
  ** 这里捕获自动登录的信息，登录用户
  */
  @HostListener("window:autoLogin", ['$event.detail'])
  onAutoLogin(token) {

    this.loginUserByToken(token);

  }
  private shouldnotRecord = false;
  private cachedPosition = 0;

  private lastRegion = null;
  hideTop = false;
  hideSticky = false;
  hideStickyChat = false;
  isFullScreen = false;
  /*
  ** 更新广告区域
  */
  updateAllGgs() {
    var region = this._storage.GetConfig()["region"] || "GL.";
    //console.log(region);
    if (this.lastRegion != region) {
      this.lastRegion = region;

      if (!this._ggService.ggs) {
        this._ggService.updateggs(region);
      } else {
        const lastUpdate = this._ggService.ggs.systime.match(/\/Date\((.*?)\)\//)[1];
        const current = Date.now();
        const lastRegion = this._ggService.ggs.country;
        if ((current - lastUpdate > 60000) || (region && (lastRegion !== region))) {
          this._ggService.updateggs(region);
        }
      }


    }
    else {
      this._ggService.record(region).subscribe();
    }

  }


  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
    if (this.watcher != null)
      this.watcher.unsubscribe();
  }

  // onConfirmed() {
  //   this.confimed = true;
  // }

  public ngAfterViewInit(): void {
    try {
      document.getElementById("__whole__").remove(); ///删除加载窗口
      var elements = document.getElementsByTagName("html");//.length
      if (elements.length > 0 && this._utility.isIphoneDevice()) {
        elements[0].classList.add("istouch")
      }
    }
    catch (err) {

    }

    if(this.isDanger)
    {
      document.getElementsByClassName("root-container").item(0).childNodes.forEach(p=>{
        let element = (p as HTMLElement);
        if(!element.classList || !element.classList.contains("danger-notify"))
        {
          p.remove();
        }
      })
    }
  }


  closeGuide() {
    let ifPlayer = false;
    if (this._utility.isUrlContains(["/watch", "/play"])) {
      ifPlayer = true;
    }
    this._guide.closeGuideCover(ifPlayer, 'all');
  }




  /*
  ** 退出当前用户
  */
  logout() {
    this._userService.logout();
    this._dnDialogService.close("prevent-dialog");
  }

  /*
  ** 解决缩放导致页面显示不全
  ** 此外在使用了window.innerHeight/window.innerWidth/window.scrollY的地方，视情况乘以缩放比例window.devicePixelRatio
  */
  //获取系统类型
  _getSystem() {
    var agent = navigator.userAgent.toLowerCase();
    //针对windows处理，其它系统如有需求，继续在此添加
    if (agent.indexOf("windows") >= 0) {
      return true;
    }

    var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
    //针对mac处理
    console.log(isMac);
    if (isMac) {
      // return true;
    }
  }
  //监听方法兼容写法
  _addHandler(element, type, handler) {
    if (element.addEventListener) {
      element.addEventListener(type, handler, false);
    } else if (element.attachEvent) {
      element.attachEvent("on" + type, handler);
    } else {
      element["on" + type] = handler;
    }
  }
  //校正浏览器缩放比例
  _correct() {
    //页面devicePixelRatio（设备像素比例）变化后，计算页面body标签zoom修改其大小，来抵消devicePixelRatio带来的变化。
    // const zoomValue = (1 / window.devicePixelRatio);
    if (innerWidth > 2560) {
      const zoomValue = (innerWidth / 1920); // 使用最大尺寸
      document.getElementsByTagName('body')[0].style['zoom'] = zoomValue.toString();
    } else {
      const zoomValue = (innerWidth / 1366); // 使用最小尺寸
      document.getElementsByTagName('body')[0].style['zoom'] = zoomValue.toString();
    }
  }
  //监听页面缩放
  _watch() {
    this._addHandler(this._utility.getWindow(), 'resize', function () { //注意这个方法是解决全局有两个window.resize
      //重新校正
      const zoomValue = (1 / this._utility.getWindow().devicePixelRatio);
      document.getElementsByTagName('body')[0].style['zoom'] = zoomValue.toString();
    })
  }


  initDevicePixelRatio() {
    const innerWidth = this._utility.getWindow().innerWidth;
    // console.log(innerWidth);
    if (innerWidth < 1275) {
      return;
    }
    if ((innerWidth < 1366 || innerWidth > 2560) && this._getSystem()) { //判断设备，innerWidth如果小于1366或大于2560启用
      //初始化页面校正浏览器缩放比例
      this._correct();
      //开启监听页面缩放
      // this._watch();
    }
  }

  leaveTo() {
  }

 

  loadInitSettings() {
    this.settingsService.loadSettings();
  }
}
